if (!customElements.get('scroll-to')) {
  customElements.define('scroll-to', class ScrollTo extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      // Find all clickable elements within this scroll-top element
      const clickableElements = this.querySelectorAll('a, button, [role="button"]');
      
      clickableElements.forEach(element => {
        element.addEventListener('click', this.handleClick.bind(this));
      });
    }

    handleClick(event) {
      // Prevent default behavior
      event.preventDefault();
      
      // Find the product-form element
      const productForm = this.findProductForm();
      
      if (productForm) {
        this.scrollToProductForm(productForm);
      } else {
        console.warn('ScrollTo: No product-form element found to scroll to');
      }
    }

    findProductForm() {
      // First, try to find product-form in the current section/container
      let productForm = this.closest('section')?.querySelector('product-form.product-form');
      
      // If not found in current section, try to find the main product form on the page
      if (!productForm) {
        productForm = document.querySelector('product-form.product-form');
      }
      
      // If still not found, try alternative selectors for product forms
      if (!productForm) {
        productForm = document.querySelector('.product-form');
      }
      
      return productForm;
    }

    scrollToProductForm(productForm) {
      // Get the element's position
      const elementRect = productForm.getBoundingClientRect();
      const absoluteElementTop = elementRect.top + window.pageYOffset;
      
      // Calculate offset to account for any fixed headers (adjust as needed)
      const offset = window.innerHeight / 2; // Adjust this value based on your header height
      const targetPosition = absoluteElementTop - offset;
      
      // Smooth scroll to the element
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }

    // Handle dynamically added elements
    connectedCallback() {
      // Use MutationObserver to handle dynamically added buttons/links
      if (this.observer) {
        this.observer.disconnect();
      }
      
      this.observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const clickableElements = node.querySelectorAll ? 
                node.querySelectorAll('a, button, [role="button"]') : 
                (node.matches && node.matches('a, button, [role="button"]') ? [node] : []);
              
              clickableElements.forEach(element => {
                element.addEventListener('click', this.handleClick.bind(this));
              });
            }
          });
        });
      });
      
      this.observer.observe(this, {
        childList: true,
        subtree: true
      });
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  });
}
